// Library imports
import * as THREE from "three";

interface IProps {
  media: any;
}

export default function AppCube({ media }: IProps) {
  const sideLength = 500;
  const geom = new THREE.PlaneGeometry(sideLength, sideLength, 1, 1);

  // console.log("media", media);

  return (
    <mesh
      visible
      rotation={new THREE.Euler(0, 0, 0)}
      geometry={new THREE.BoxGeometry(500, 500, -500)}
      material={media}
    />
  );
}
